import { render, staticRenderFns } from "./BulkOperationDocuments.vue?vue&type=template&id=436e5cec&scoped=true&"
import script from "./BulkOperationDocuments.vue?vue&type=script&lang=js&"
export * from "./BulkOperationDocuments.vue?vue&type=script&lang=js&"
import style0 from "./BulkOperationDocuments.vue?vue&type=style&index=0&id=436e5cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e5cec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VList,VListItem,VListItemContent,VListItemTitle,VMenu})
